(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["explore-product-gallery-enhancements"] && !Shopify.designMode) return;
  try {
    (function() {
    var MOBILE_QUERY = '(max-width: 768px)';
    var ZOOM_SCALE = 1.82;
    var PAN_SPEED = 1.1;

    function initGallery(root) {
      if (!root || root.dataset.epProductZoomReady === 'true') return;

      var slider = root.querySelector('[id^="ProductPhotos-"]');
      var button = root.querySelector('[data-ep-product-zoom-toggle]');
      var nextButton = root.querySelector('[data-ep-product-gallery-next]');
      var progress = root.querySelector('[data-ep-product-gallery-progress]');
      var progressThumb = root.querySelector('[data-ep-product-gallery-progress-thumb]');
      if (!slider || !button) return;

      root.dataset.epProductZoomReady = 'true';

      var zoomedSlide = null;
      var zoomedImage = null;
      var zoomedWrap = null;
      var zoomInLabel = button.querySelector('[data-ep-zoom-in]');
      var zoomOutLabel = button.querySelector('[data-ep-zoom-out]');
      var slickEventsBound = false;
      var slickNormalized = false;

      var panX = 0;
      var panY = 0;
      var dragStartX = 0;
      var dragStartY = 0;
      var dragStartPanX = 0;
      var dragStartPanY = 0;
      var dragging = false;
      var activePointerId = null;

      function isMobile() {
        return window.matchMedia ? window.matchMedia(MOBILE_QUERY).matches : window.innerWidth <= 768;
      }

      function getJquerySlider() {
        if (!window.jQuery) return null;
        return window.jQuery(slider);
      }

      function isSlickReady() {
        var $slider = getJquerySlider();
        return !!($slider && $slider.hasClass('slick-initialized') && typeof $slider.slick === 'function');
      }

      function getRealSlides() {
        var slides = Array.prototype.slice.call(slider.querySelectorAll('.slick-slide:not(.slick-cloned)'));
        if (slides.length) return slides;

        return Array.prototype.slice.call(slider.children).filter(function(slide) {
          return slide.classList && (slide.classList.contains('starting-slide') || slide.classList.contains('secondary-slide'));
        });
      }

      function getActiveSlide() {
        return slider.querySelector('.slick-slide.slick-current:not(.slick-cloned)') ||
          slider.querySelector('.slick-slide[aria-hidden="false"]:not(.slick-cloned)') ||
          slider.querySelector('.starting-slide') ||
          getRealSlides()[0] ||
          null;
      }

      function isZoomable(slide) {
        if (!slide) return false;
        if (slide.querySelector('.product__video-wrapper, [data-product-media-type-model], model-viewer')) return false;
        return !!slide.querySelector('.image-wrap img');
      }

      function setSlickInteraction(enabled) {
        if (!isSlickReady()) return;
        var $slider = getJquerySlider();

        try {
          $slider.slick('slickSetOption', 'swipe', enabled, false);
          $slider.slick('slickSetOption', 'draggable', enabled, false);
          $slider.slick('slickSetOption', 'touchMove', enabled, false);
        } catch (error) {}
      }

      function normalizeSlickForMobile() {
        if (!isMobile() || !isSlickReady()) return;

        var $slider = getJquerySlider();

        if (!slickNormalized) {
          try {
            $slider.slick('slickSetOption', 'centerMode', false, false);
            $slider.slick('slickSetOption', 'variableWidth', false, false);
            $slider.slick('slickSetOption', 'slidesToShow', 1, false);
            $slider.slick('slickSetOption', 'slidesToScroll', 1, true);
            slickNormalized = true;
          } catch (error) {}
        }

        var list = slider.querySelector('.slick-list');
        if (list) {
          list.style.setProperty('overflow', 'hidden', 'important');
          list.style.setProperty('padding-left', '0', 'important');
          list.style.setProperty('padding-right', '0', 'important');
          list.style.setProperty('margin-left', '0', 'important');
          list.style.setProperty('margin-right', '0', 'important');
        }

        try {
          $slider.slick('setPosition');
        } catch (error) {}
      }

      function getActiveIndex() {
        var slides = getRealSlides();
        var activeSlide = getActiveSlide();
        var index = slides.indexOf(activeSlide);

        if (index < 0 && activeSlide) {
          var slickIndex = parseInt(activeSlide.getAttribute('data-slick-index'), 10);
          if (!isNaN(slickIndex)) index = Math.max(0, Math.min(slides.length - 1, slickIndex));
        }

        return Math.max(0, index);
      }

      function updateProgress() {
        if (!progress || !progressThumb) return;

        var slides = getRealSlides();
        var total = slides.length;
        if (!isMobile() || total <= 1) {
          progress.hidden = true;
          return;
        }

        var index = getActiveIndex();
        progress.hidden = false;

        var trackWidth = progress.clientWidth || (window.innerWidth <= 380 ? 62 : 68);
        var thumbWidth = Math.max(14, Math.min(trackWidth, Math.round(trackWidth / total)));
        var maxLeft = Math.max(0, trackWidth - thumbWidth);
        var left = total > 1 ? maxLeft * (index / (total - 1)) : 0;

        progressThumb.style.width = thumbWidth + 'px';
        progressThumb.style.transform = 'translate3d(' + left.toFixed(1) + 'px,0,0)';
      }

      function updateNextControl() {
        if (!nextButton) return;

        var slides = getRealSlides();
        var total = slides.length;
        var index = getActiveIndex();
        nextButton.hidden = !isMobile() || total <= 1 || index >= total - 1;
      }

      function setButtonState() {
        var activeSlide = getActiveSlide();
        var canZoom = isZoomable(activeSlide);
        var isZoomed = canZoom && zoomedSlide === activeSlide && activeSlide.classList.contains('ep-product-slide--zoomed');

        button.hidden = !canZoom;
        button.setAttribute('aria-pressed', isZoomed ? 'true' : 'false');
        button.setAttribute('aria-label', isZoomed ? 'Zoom out product image' : 'Zoom in product image');

        if (zoomInLabel) zoomInLabel.hidden = isZoomed;
        if (zoomOutLabel) zoomOutLabel.hidden = !isZoomed;
      }

      function clamp(value, min, max) {
        return Math.min(max, Math.max(min, value));
      }

      function getPanBounds() {
        if (!zoomedWrap) return { x: 0, y: 0 };

        return {
          x: Math.max(0, zoomedWrap.clientWidth * (ZOOM_SCALE - 1) / 2),
          y: Math.max(0, zoomedWrap.clientHeight * (ZOOM_SCALE - 1) / 2)
        };
      }

      function applyPan() {
        if (!zoomedImage) return;

        var bounds = getPanBounds();
        panX = clamp(panX, -bounds.x, bounds.x);
        panY = clamp(panY, -bounds.y, bounds.y);

        zoomedImage.style.setProperty(
          'transform',
          'translate3d(' + panX.toFixed(1) + 'px,' + panY.toFixed(1) + 'px,0) scale(' + ZOOM_SCALE + ')',
          'important'
        );
      }

      function endDrag() {
        dragging = false;
        activePointerId = null;
        root.classList.remove('ep-product-gallery--dragging');
      }

      function resetZoom(refreshState) {
        endDrag();

        if (zoomedSlide) {
          zoomedSlide.classList.remove('ep-product-slide--zoomed');
        }

        if (zoomedImage) {
          zoomedImage.style.removeProperty('transform');
          zoomedImage.style.removeProperty('transform-origin');
        }

        zoomedSlide = null;
        zoomedImage = null;
        zoomedWrap = null;
        panX = 0;
        panY = 0;

        root.classList.remove('ep-product-gallery--zoomed');
        setSlickInteraction(true);

        if (refreshState !== false) setButtonState();
      }

      function startZoom() {
        var activeSlide = getActiveSlide();
        if (!isZoomable(activeSlide)) return;

        resetZoom(false);

        zoomedSlide = activeSlide;
        zoomedWrap = activeSlide.querySelector('.image-wrap');
        zoomedImage = activeSlide.querySelector('.image-wrap img');
        if (!zoomedWrap || !zoomedImage) {
          resetZoom(true);
          return;
        }

        panX = 0;
        panY = 0;
        zoomedSlide.classList.add('ep-product-slide--zoomed');
        root.classList.add('ep-product-gallery--zoomed');
        zoomedImage.style.setProperty('transform-origin', '50% 50%', 'important');
        applyPan();

        setSlickInteraction(false);
        setButtonState();
      }

      function toggleZoom(event) {
        event.preventDefault();
        event.stopPropagation();

        var activeSlide = getActiveSlide();
        if (!isZoomable(activeSlide)) return;

        if (zoomedSlide === activeSlide && activeSlide.classList.contains('ep-product-slide--zoomed')) {
          resetZoom(true);
        } else {
          startZoom();
        }
      }

      function beginDrag(clientX, clientY) {
        if (!zoomedSlide || !zoomedWrap || !zoomedImage) return false;

        dragging = true;
        dragStartX = clientX;
        dragStartY = clientY;
        dragStartPanX = panX;
        dragStartPanY = panY;
        root.classList.add('ep-product-gallery--dragging');
        return true;
      }

      function moveDrag(clientX, clientY) {
        if (!dragging || !zoomedImage) return;

        panX = dragStartPanX + (clientX - dragStartX) * PAN_SPEED;
        panY = dragStartPanY + (clientY - dragStartY) * PAN_SPEED;
        applyPan();
      }

      function bindPanEvents() {
        if (window.PointerEvent) {
          root.addEventListener('pointerdown', function(event) {
            if (!zoomedWrap || !zoomedWrap.contains(event.target)) return;
            if (event.pointerType === 'mouse' && event.button !== 0) return;

            activePointerId = event.pointerId;
            if (!beginDrag(event.clientX, event.clientY)) return;

            try {
              zoomedWrap.setPointerCapture(event.pointerId);
            } catch (error) {}

            event.preventDefault();
            event.stopPropagation();
          }, { passive: false });

          root.addEventListener('pointermove', function(event) {
            if (!dragging || activePointerId !== event.pointerId) return;
            event.preventDefault();
            event.stopPropagation();
            moveDrag(event.clientX, event.clientY);
          }, { passive: false });

          root.addEventListener('pointerup', function(event) {
            if (activePointerId !== event.pointerId) return;
            endDrag();
          });

          root.addEventListener('pointercancel', function(event) {
            if (activePointerId !== event.pointerId) return;
            endDrag();
          });
        } else {
          root.addEventListener('touchstart', function(event) {
            if (!zoomedWrap || !zoomedWrap.contains(event.target) || !event.touches.length) return;
            var point = event.touches[0];
            if (!beginDrag(point.clientX, point.clientY)) return;
            event.preventDefault();
            event.stopPropagation();
          }, { passive: false });

          root.addEventListener('touchmove', function(event) {
            if (!dragging || !event.touches.length) return;
            var point = event.touches[0];
            event.preventDefault();
            event.stopPropagation();
            moveDrag(point.clientX, point.clientY);
          }, { passive: false });

          root.addEventListener('touchend', endDrag);
          root.addEventListener('touchcancel', endDrag);
        }
      }

      function goNext(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (!isSlickReady()) return;
        resetZoom(false);

        try {
          getJquerySlider().slick('slickNext');
        } catch (error) {}
      }

      function syncGallery() {
        normalizeSlickForMobile();

        var activeSlide = getActiveSlide();
        if (zoomedSlide && activeSlide !== zoomedSlide) resetZoom(false);

        setButtonState();
        updateProgress();
        updateNextControl();
      }

      function bindSlickEvents() {
        if (!isSlickReady() || slickEventsBound) return false;

        var $slider = getJquerySlider();
        slickEventsBound = true;

        $slider.on('beforeChange.epProductGallery', function() {
          resetZoom(false);
        });

        $slider.on('afterChange.epProductGallery reInit.epProductGallery setPosition.epProductGallery', function() {
          window.setTimeout(syncGallery, 0);
        });

        syncGallery();
        return true;
      }

      button.addEventListener('click', toggleZoom);
      if (nextButton) nextButton.addEventListener('click', goNext);
      bindPanEvents();

      root.addEventListener('click', function(event) {
        if (!zoomedSlide || button.contains(event.target)) return;
        if (nextButton && nextButton.contains(event.target)) return;

        if (zoomedSlide.contains(event.target)) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, true);

      var tries = 0;
      var readyTimer = window.setInterval(function() {
        tries += 1;
        if (bindSlickEvents() || tries >= 30) {
          window.clearInterval(readyTimer);
          syncGallery();
        }
      }, 100);

      window.setTimeout(syncGallery, 250);
      window.setTimeout(syncGallery, 700);

      var resizeTimer;
      window.addEventListener('resize', function() {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(function() {
          if (zoomedSlide) {
            panX = 0;
            panY = 0;
            applyPan();
          }
          syncGallery();
        }, 120);
      });

      setButtonState();
      updateProgress();
      updateNextControl();
    }

    function initAll(scope) {
      var context = scope && scope.querySelectorAll ? scope : document;
      var galleries = context.querySelectorAll('[data-ep-product-gallery]');
      Array.prototype.forEach.call(galleries, initGallery);
    }

    function boot() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('page:loaded', boot);
    document.addEventListener('shopify:section:load', function(event) {
      initAll(event.target || document);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
